module.exports = __webpack_public_path__ + "static/media/authorAvatar1.66d60173.jpeg";